export default [
  {
    path: 'role/management',
    name: 'RoleManagement',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/role/Index`)
  }
]
